/* eslint-disable @typescript-eslint/naming-convention */
import type { GlobalFieldReference, Heading, Html } from '@ps/web-martech-cms-types';
import type {
  DateTimePickerBlock,
  DropdownBlock,
  TextBoxBlock,
  ToggleBlock
} from '@ps/web-martech-cms-types/Form';
import React from 'react';

import { CMSHTML, CMSHeading } from '@swf/cms';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import formStyles from '../CMSForm.scss';

import DateTimePicker from './DateTimePicker';
import DropdownSelector from './DropdownSelector';
import TextBox from './TextBox';
import ToggleInput from './ToggleInput/ToggleInput';

export interface FormBlockLoader {
  blockType: string;
  data: GlobalFieldReference | TextBoxBlock | DropdownBlock | DateTimePickerBlock | ToggleBlock;
}

const BlockLoader: React.FC<FormBlockLoader> = ({ blockType, data }) => {
  switch (blockType) {
    case 'heading':
      return (
        <CMSHeading {...(data as { heading: Heading }).heading} className={formStyles.heading} />
      );
    case 'text_box':
      return <TextBox {...(data as TextBoxBlock).text_box} />;
    case 'dropdown':
      return <DropdownSelector {...(data as DropdownBlock).dropdown} />;
    case 'date_time_picker':
      return <DateTimePicker {...(data as DateTimePickerBlock).date_time_picker} />;
    case 'toggle':
      return <ToggleInput {...(data as ToggleBlock).toggle} />;
    case 'html':
      return <CMSHTML {...(data as { html: Html }).html} />;
    default:
      return null;
  }
};

export default BlockLoader;
